import { useEffect, useState } from 'react'

/**
 * useMediaQuery — 响应式 media query hook
 * @param {string} query CSS media query string，例如 '(max-width: 1023.98px)'
 * @returns {boolean} 当前 query 是否匹配
 */
export function useMediaQuery(query) {
  const getMatch = () => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return false
    }
    return window.matchMedia(query).matches
  }

  const [matches, setMatches] = useState(getMatch)

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return undefined
    }

    const mql = window.matchMedia(query)
    const handler = (event) => setMatches(event.matches)

    setMatches(mql.matches)

    if (mql.addEventListener) {
      mql.addEventListener('change', handler)
      return () => mql.removeEventListener('change', handler)
    }

    mql.addListener(handler)
    return () => mql.removeListener(handler)
  }, [query])

  return matches
}

export default useMediaQuery
